<template>
    <BreadCrumb PageTitle="Add Task Type" />
    <AddTaskType />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import AddTaskType from "../../components/TaskTypes/AddTaskType.vue";
  
  export default defineComponent({
    name: "AddTaskTypePage",
    components: {
      BreadCrumb,
      AddTaskType,
    },
  });
  </script>